<script>
import $store from '@/store'
import { firstAvailable } from '@/router/util'

export default {
  functional: true,
  beforeRouteEnter(to, from, next) {
    const currentUserId = $store.state.user.currentUser.id

    if (currentUserId) return next({ name: firstAvailable() })
    else return next({ name: 'login' })
  },
}
</script>
